import * as USER from '../constants/user';


export default {
  [USER.MUTATE_USER]: (state, data) => {
    state.user = data;
  },

  [USER.MUTATE_LIST_USER]: (state, users) => {
    state.users = users;
  }
}


// WEBPACK FOOTER //
// ./src/store/user/mutations.js